var innerRemote;
function attachRemote (resolve) {
	if(__webpack_require__.m[47160]) {
		innerRemote = __webpack_require__(47160);
	}
	var gs = __webpack_require__.g || globalThis
	gs["pmc"] = innerRemote
	if(resolve) resolve(innerRemote);
	return innerRemote;
};
__webpack_require__.federation.attachRemote = attachRemote;
attachRemote();